import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../providers/AppAuthProvider';

import Loader from './Loader';

interface ProtectedRouteProps {
	children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const { isAuthenticated, loading } = useAuth();
	const location = useLocation();

	if (loading) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<Loader size="lg" text="Loading..." />
			</div>
		);
	}

	if (!isAuthenticated) {
		// Redirect to auth page with the return url; LoginPage handles type=login/signup
		return (
			<Navigate to="/auth?type=login" state={{ from: location }} replace />
		);
	}

	return <>{children}</>;
};

export default ProtectedRoute;
